<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                passive
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('config.add_policies') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            top="2%"
            width="60%"
            :title="$t('config.add_data_policies')"
            :visible.sync="modals.create"
            :close-on-click-modal="false"
          >
            <p>
              {{ $t('common_words.info_policies') }}
            </p>
            <hr />
            <form>
              <div class="row">
                <div class="col-4">
                  <fg-input
                    ref="version"
                    type="text"
                    :label="`${$t('common_words.version')} *`"
                    v-model="model.version"
                    name="common_words.version"
                    v-validate="modelValidations.version"
                    :error="getError('common_words.version', true)"
                    placeholder="v. 1.0.1 ..."
                  >
                  </fg-input>
                </div>

                <div class="col-8">
                  <fg-input
                    ref="url"
                    type="text"
                    label="URL *"
                    v-model="model.url"
                    name="url"
                    v-validate="modelValidations.url"
                    :error="getError('url')"
                    placeholder="http.//..."
                  >
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-area">{{
                      $t('common_words.description')
                    }}</label>
                    <VueTrix
                      inputId="editor1"
                      v-model="model.description"
                      :placeholder="`${$t('common_words.description')}...`"
                    />
                  </div>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.save') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                :align="'center'"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="200"
                prop="props.description"
                :label="$t('common_words.description')"
                :sortable="true"
                :resizable="false"
                :align="'center'"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.description.length > 0"
                    :hidden="scope.row.description.length == 1 ? true : false"
                    :value="scope.row.description.length"
                    :max="scope.row.description.length - 1"
                  >
                    <el-button plain type="main" size="small">
                      <span
                        v-html="scope.row.description.substring(0, 30)"
                      ></span
                      >{{ scope.row.description.length > 30 ? `...` : `` }}
                    </el-button>
                  </el-badge>
                </template>
              </el-table-column>

              <el-table-column
                min-width="160"
                prop="props.users_registered"
                :label="$t('common_words.registered_users')"
                :sortable="true"
                :resizable="false"
                :align="'center'"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.users_registered.length > 0"
                    :hidden="
                      scope.row.users_registered.length == 1 ? true : false
                    "
                    :value="200"
                    :max="scope.row.users_registered.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.users_registered[0].name }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>

              <el-table-column
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      top="2%"
      v-if="isShow()"
      :title="`${$t('common_words.record_selected')}...`"
      :visible.sync="modals.read"
      width="60%"
    >
      <p>
        {{ $t('common_words.selected_record_info') }}
      </p>
      <div class="card" v-if="rowData">
        <div class="card-body" v-if="rowData">
          <table class="table">
            <tbody>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('common_words.version') }}:</strong>
                  </h6>
                  {{ rowData.version }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6><strong>URL:</strong></h6>
                  {{ rowData.url }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('common_words.description') }}:</strong>
                  </h6>
                  <span v-html="rowData.description"></span>
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6 class="custom-margin-h6-table">
                    <strong>{{ $t('common_words.registered_users2') }}:</strong>
                  </h6>
                  <span
                    v-for="(user, index) in rowData.users_registered"
                    :key="index"
                  >
                    <el-tag type="info">{{ user.name }}</el-tag>
                    <br v-if="index % 5 == 0 && index != 0" />
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer footer-date-at" v-if="rowData">
          <p class="text-white">
            <small
              >{{ $t('common_words.created_on') }}:
              {{ rowData.created_at }}</small
            >
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification';
import { Pagination as LPagination } from 'src/components/index';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import configTable from './policies-table';
import SweetAlert from 'src/class/Alerts';
import VueTrix from 'vue-trix';
import i18n from '../../../../i18n';
import MixinTranslate from 'src/util/mixinTranslate';

export default {
  components: {
    LPagination,
    VueTrix,
  },

  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        create: false,
      },
      model: {
        version: null,
        url: null,
        description: null,
        other_values: [],
      },
      modelValidations: {
        version: {
          required: true,
        },
        url: {
          required: true,
        },
        description: {
          required: true,
        },
      },
    };
  },

  mixins: [
    MixinMasters,
    MixinPermissions,
    MixinMenu,
    MixinExport,
    MixinForm,
    MixinNotification,
    MixinTranslate,
  ],
  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      if (name == 'create') {
        sessionStorage.removeItem('editForm');
        this.title = i18n.t('config.add_policies');
        this.$validator.reset();
        this.model.version = null;
      }
      this.modals[name] = true;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.addPolicy();
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = 'policies';
      sessionStorage.setItem('editForm', JSON.stringify(row));
      this.title = i18n.t('config.edit_policies') + row.version;
      this.model = Object.assign({}, row);
      this.errors.clear();
      this.model.route = 'policies';
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.model = row;
      SweetAlert.delete(
        i18n.t('common_words.version') + this.model.version
      ).then((result) => {
        if (result.value) this.deletePolicy();
      });
    },

    addPolicy() {
      this.showHideLoading(true);
      this.model.route = 'policies';
      if (this.isCreate() && !sessionStorage.getItem('editForm')) {
        Axios.saveMaster(this.model)
          .then((response) => {
            this.modifyTable(0, null, response);
          })
          .catch((error) => {
            this.closeModal('create');
            this.showNotification(
              ` ${error.response.data.message}`,
              'danger',
              'nc-simple-add',
              i18n.t('common_words.alert')
            );
            this.showHideLoading();
          });
      } else if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;
        Axios.updateMaster(this.model)
          .then((response) => {
            this.modifyTable(1, this.model.id, response);
            sessionStorage.removeItem('editForm');
          })
          .catch((error) => {
            this.closeModal('create');
            this.showNotification(
              ` ${error.response.data.message}`,
              'danger',
              'nc-simple-add',
              i18n.t('common_words.alert')
            );
            this.showHideLoading();
            sessionStorage.removeItem('editForm');
          });
      }
    },

    deletePolicy() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'policies';
        // this.model.user_id = store.state.auth.user.id;
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.modifyTable(2, this.model.id, response);
          })
          .catch((error) => {
            this.showHideLoading();
            SweetAlert.danger(
              error.response.data.message ? error.response.data.message : error
            );
          });
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'policies/pdf';
      data.name_file = `${i18n.t('config.policies')}.pdf`;

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'policies/excel';
      data.name_file = `${i18n.t('config.policies')}.xlsx`;

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([Axios.getMasters('policies')])
        .then((response) => {
          const [response_policys] = response;
          this.tableData = response_policys.data.data;
          this.searchFuse(
            this.tableColumns.map((column) => {
              return column.prop;
            })
          );
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('policies');
  },

  destroyed() {
    this.deselectedItemOnMenu('policies');
  },
};
</script>
